// extracted by mini-css-extract-plugin
export default {"faqList-accordion-container":"Faq_faqList-accordion-container__9yiJL","plus":"Faq_plus__4NPIZ"};